import { render, staticRenderFns } from "./AdditionalCountryInfo.vue?vue&type=template&id=0523770a&scoped=true"
import script from "./AdditionalCountryInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalCountryInfo.vue?vue&type=script&lang=js"
import style0 from "./AdditionalCountryInfo.vue?vue&type=style&index=0&id=0523770a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523770a",
  null
  
)

export default component.exports